module.exports = __webpack_public_path__ + "img/ogp.6616d34.jpg";